// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createVerticalSmallHeadingAndTextStyles } from "@eisinc/App/SharedStyles/smallHeadingAndTextStyles";
import { staticListProductListLineStyles } from "@eisinc/Overrides/Widgets/StaticList/StaticListProductListLine";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { color, xScreen } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

staticListProductListLineStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: 92px minmax(0px, 1fr) 330px;
        column-gap: 12px;
        width: 100%;
        padding-block: 12px;
        border-bottom: 1px solid ${color("common.ui3")};
        ${xScreen("lte", "sm")} {
            grid-template-columns: 92px 1fr;
        }
    `,
};
staticListProductListLineStyles.infoWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        column-gap: 12px;
    `,
};
staticListProductListLineStyles.descriptionGridItem = {
    css: css`
        width: 100%;
    `,
};
staticListProductListLineStyles.innerInfo = {
    css: css`
        display: flex;
        flex-direction: column;
        width: calc(50% - 6px);
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
}
staticListProductListLineStyles.availabilityGridItem = {
    css: css`
        width: calc(50% - 6px);
        padding-left: 12px;
        ${xScreen("lte", "sm")} {
            width: 100%;
            padding: 0;
        }    
    `,
};
staticListProductListLineStyles.atcWrapper = {
    css: css`
        display: flex;
        width: 100%;
        gap: 8px;
    `,
};
staticListProductListLineStyles.imageWrapper = {

};
staticListProductListLineStyles.buttonsGridItem = {
    printWidth: 0,
    css: css`
        display: flex;
        flex-direction: column;
        padding-left: 12px;
        border-left: 1px solid ${color("common.ui3")};
        gap: 8px;
        ${xScreen("lte", "sm")} {
            border: none;
            width: 100%;
            padding-left: 0;
            grid-column: 2/3;
        }
        ${xScreen("lte", "xs")} {
            grid-column: 1/3;
        }
    `,
};
staticListProductListLineStyles.notesStyles = {
    ...createVerticalSmallHeadingAndTextStyles({
        heading: {
            ...fontConfig.singleLinexSmall,
        },
        text: {
            ...fontConfig.singleLinexSmall,
        },
    }),
};
staticListProductListLineStyles.productBrandStyles = {};
staticListProductListLineStyles.productPriceStyles = {};
staticListProductListLineStyles.addToCartButton = {
    sizeVariant: "small",
    css: css`
        flex-grow: 1;
    `,
};
staticListProductListLineStyles.productQuantityOrderedStyles = {};

staticListProductListLineStyles.partNumbersGridItem = {
    css: css`
        margin-bottom: 2px;
    `,
};
staticListProductListLineStyles.productUnitOfMeasureSelectStyles = {
    sizeVariant: "small",
};
staticListProductListLineStyles.addToListLink = {
    wrapper: {
        css: css`
            margin-top: auto;
        `,
    }
};
staticListProductListLineStyles.productImageStyles = {
    linkWrappingImage: {
        css: css`
                width: 92px;
                height: 92px;
                position: relative;
                &&& > img {
                    aspect-ratio: 1;
                    object-fit: contain;
                    font-size: 14px;
                }

                @media print {
                    display: none;
                }
            `,
    },
    image: {
        css: css`
                width: auto;
                height: auto;
                max-width: 92px;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            `,
    },

}